<ui-input-select-wrapper #selectWrapper [open]="open()" [noOverlay]="noOverlay()">
    <ui-input-wrapper
        [label]="label()"
        [value]="selectedValue()?.label ?? value() ?? undefined"
        [focussed]="focussed()"
        [error]="error()"
        [errorMsg]="errorMsg()"
        [disabled]="isDisabled()"
    >
        <input
            class="flex h-full w-full items-center px-16 text-black transition-all outline-none"
            [id]="inputId"
            [value]="selectedValue()?.label ?? value()"
            [disabled]="isDisabled()"
            (input)="onInput($event)"
            (focus)="_onTouch?.(); focussed.set(true)"
            (blur)="focussed.set(false)"
            (keypress)="$event.keyCode === 13 ? onEnter() : null"
            type="text"
        />
        @if (withIcon()) {
            <button
                [disabled]="isDisabled()"
                [ngClass]="{ 'opacity-50': isDisabled() }"
                (click)="onButtonClick()"
                type="button"
            >
                <i class="icon-search text-22 mr-16"></i>
            </button>
        }
    </ui-input-wrapper>

    <div class="flex w-full flex-col" dropdown>
        @for (option of autocompleteOptions(); let i = $index; track i) {
            <button
                class="hover:bg-grey-100 flex items-center px-16 py-12 text-left text-wrap transition-colors"
                (click)="selectAutocomplete(option)"
            >
                {{ option.label }}
            </button>
        }
    </div>
</ui-input-select-wrapper>
